import React from "react";
import Graph from "../../../../etc/Graph";
import LineChart from "../../../../etc/LineChart";
import img from "../../../../../assets/images/journal/j-graph-sample.jpg";

const JImpactFactorChange = (parent) => {
	const meta = parent.meta;
	const result = {};
	result.labels = [];
	result.SCI = {};
	result.SCI.data = [];
	result.SCI.color = 'rgb(115,117,173)';
	result.SCOPUS = {};
	result.SCOPUS.data = [];
	result.SCOPUS.color = 'rgb(223,142,96)';
	result.KCI = {};
	result.KCI.data = [];
	result.KCI.color = 'rgb(109,170,176)';

	// console.log(meta.impact_factor_graph)
	if (meta.impact_factor_graph) {
		// console.log(meta.impact_factor_graph)
		let year = [];
		let temp = {};
		temp.SCI = {};
		temp.SCOPUS = {};
		temp.KCI = {};

		Object.keys(meta.impact_factor_graph).map((item, key) => {
			meta.impact_factor_graph[item].map((i, k) => {
				item = item.toUpperCase();
				temp[item][i.indicator_year] = i.impact;
				year.push(i.indicator_year);
			})
		});

		if (year.length > 2) {
			result.labels = year.slice().sort(function(a,b){return a - b}).reduce(function(a,b){if (a.slice(-1)[0] !== b) a.push(b);return a;},[]);
		}

		result.labels.map((year, num) => {
			result.SCI.data.push(temp.SCI[year]);
			result.SCOPUS.data.push(temp.SCOPUS[year]);
			result.KCI.data.push(temp.KCI[year]);
		});
	}

	if (!meta.error_code && Object.keys(result.labels).length <= 0)
		return '';

	return (
		<div className="mt-65 journal-detail-impactchange">
			<div className="d-flex justify-content-between align-items-center mb-px-26">
				<div className="d-flex align-items-center">
					<h3 className="con-title">Impact Factor 변동추이</h3>
				</div>
				<div className="d-flex align-items-center">
					<div className="chart-label mr-4">
						<div className="label-color bg-lightpurple"/>
						<div className="label-subject">SCI급</div>
					</div>
					<div className="chart-label mr-4">
						<div className="label-color bg-lightorange"/>
						<div className="label-subject">Scopus</div>
					</div>
					<div className="chart-label">
						<div className="label-color bg-lightgreen"/>
						<div className="label-subject">KCI</div>
					</div>
				</div>
			</div>
			{meta.error_code ?
				<img src={img} style={{width: "100%"}}/>
				:
				<>
					<div className="line-chart-data">
						<LineChart records={result}/>
					</div>
				</>
			}
		</div>
	);
};

export default JImpactFactorChange;
